export const OPEN_REQUESTS = 'Open requests'
export const SOLVED_REQUESTS = 'Solved requests'
